exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img {\n  max-height: 300px;\n  max-width: 600px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/rafaelneves/code/ads/ardaexperience/src/app/pages/home-travels/home-travels.component.scss
// module id = ../../../../../src/app/pages/home-travels/home-travels.component.scss
// module chunks = main